import ServicePlanBillingPoliciesTable from 'src/features/servicePlanBillingPolicies/components/tables/ServicePlanBillingPoliciesTable';
import { useServicePlanItemTabContext } from 'src/features/servicePlanItems/utils/tabContext';

/** Billing policies tab; takes the item's active flag from the outlet context. */
const ServicePlanBillingPoliciesTab = () => {
    const { isServicePlanItemActive } = useServicePlanItemTabContext();

    return <ServicePlanBillingPoliciesTable isServicePlanItemActive={isServicePlanItemActive} />;
};

export default ServicePlanBillingPoliciesTab;
